import ky from 'lib/ky'
// import MediaQuery from 'lib/media-query'

async function CustomerName () {
  const mountPoints = document.querySelectorAll('.customer_name_mount_point')
  // TODO:
  // const nameLimit = MediaQuery.current.name === 'medium' ? 7 : 999
  // ${firstName.length > nameLimit ? firstName.slice(0, nameLimit - 3) + '..' : firstName}

  function update (html) {
    mountPoints.forEach(element => element.insertAdjacentHTML('afterbegin', html))
  }

  async function render ({ firstName, cabinetPath, signInPath }) {
    if (firstName && cabinetPath) {
      update(
        `<a href="${cabinetPath}" class="customer_name">${firstName}</a>`,
      )
    } else {
      const signInUrl = new URL(signInPath || '/customers', window.location)
      if (window.location.pathname !== '/') signInUrl.searchParams.set('_return_url', window.location)
      update(
        `<a href="${signInUrl}" class="signin_button">`
        + 'Log In'
        + '</a>',
      )
    }
  }

  let customer = {}

  try {
    customer = await ky.get('/customers.json').json()
  } finally {
    render(customer)
    document.dispatchEvent(new Event('customer:loaded:maybe', { customer }))
  }
}

export default CustomerName
